import { de_RenameSimulationCommand, se_RenameSimulationCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class RenameSimulationCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("SimulationService", "RenameSimulation", {})
    .n("SimulationServiceClient", "RenameSimulationCommand")
    .f(void 0, void 0)
    .ser(se_RenameSimulationCommand)
    .de(de_RenameSimulationCommand)
    .build() {
}
